module.exports = __webpack_public_path__ + "img/venueone-wdjp.0cd51f80.png";